// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3QUoq","title":"BackImages_title__3SgSV","images":"BackImages_images__3CIef"};